import {useEffect, useState} from 'react';
import {Modal, Button, Form, Input,  Popconfirm, message} from 'antd';
import {useApi} from "../provider/ApiProvider";
import CompanySelector from "../components/CompanySelector";
import RoleSelector from "../components/RoleSelector";

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
};

const {TextArea} = Input;

export default function UserDialog({open, data, onChange, onClose,type}){

    const {api} = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(data){
            form.setFieldsValue(data);

        }else{
            form.resetFields();
        }
    },[data])

    const handleOk = () => {

    };

    const handleCancel = () => {
        onClose();
    };

    const onFinish = (values) => {
        if(data === null){
            setLoading(true);
            api.post("/userRouter/user/store",values).then(resp => {
                onClose();
                onChange();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }else{

            if(type === "ticket"){
                setLoading(true);
                api.put("/userRouter/user/save-ticket/" + data.id,values).then(resp => {
                    onClose();
                    onChange();
                    setLoading(false);
                }).finally(() => {
                    setLoading(false);
                })
            }else{

                setLoading(true);
                api.put("/userRouter/user/update/" + data.id,values).then(resp => {
                    onClose();
                    onChange();
                    setLoading(false);
                }).finally(() => {
                    setLoading(false);
                })
            }

        }

    };

    const onFinishFailed = (errorInfo) => {

    }

    const onDelete = (record) => {


    }

    return (
        <Modal
            title={type === "ticket" ? "Yemek Kartı" : (data === null || data === undefined) ? "Kullanıcı Ekle" : "Düzenle"}
            visible={open}
            okType={"submit"}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button  key="back" onClick={handleCancel}>
                    İptal
                </Button>,
                type === "ticket" ?
                <Button  form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Kaydet
                </Button>
                :
                    <Button  form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleOk}>
                        Kaydet
                    </Button>
                ,
            ]}
        >

            {type === "ticket" ?
                <Form
                    form={form}
                    id="company-dialog-form"
                    onFinish={onFinish}
                    onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                    initialValues={data}
                    labelCol={{
                        span: 5,
                    }}
                    wrapperCol={{
                        span: 19,
                    }}
                >
                    <Form.Item
                        label="Yemek Fişi"
                        name="ticketCount"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>

                </Form>


                :



                <Form
                    form={form}
                    id="company-dialog-form"
                    onFinish={onFinish}
                    onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                    initialValues={data}
                    labelCol={{
                        span: 5,
                    }}
                    wrapperCol={{
                        span: 19,
                    }}
                >
                    <Form.Item
                        label="Adı"
                        name="firstName"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Soyadı"
                        name="lastName"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="TC No"
                        name="identityNumber"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Telefon"
                        name="phone"

                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Email"
                        name="email"

                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Firma/Şube"
                        name="CompanyId"
                        rules={[
                            {
                                required: true,
                                message: 'Platform seçiniz',
                            },
                        ]}
                    >
                        <CompanySelector
                            value={form.getFieldValue('CompanyId')}
                            onChange={(id,value) =>{
                                form.setFieldsValue(
                                    {
                                        CompanyId: id,
                                        PlatformId: value?.Platform?.id,
                                        CustomerId: value?.Customer?.id,
                                        PlatformName: value?.Platform?.name,
                                        CustomerName:value?.Customer?.name,
                                    })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Adres"
                        name="address"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',
                            },
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item

                        label="Platform"
                        name="PlatformName"
                        rules={[
                            {
                                //required: true,
                                //message: 'Bu alanı doldurunuz',

                            },
                        ]}
                    >
                        <Input  disabled />
                    </Form.Item>
                    <Form.Item

                        label="Müşteri"
                        name="CustomerName"
                        rules={[
                            {
                                //required: true,
                                //message: 'Bu alanı doldurunuz',

                            },
                        ]}
                    >
                        <Input  disabled />
                    </Form.Item>
                    <Form.Item

                        label="Rol"
                        name="RoleId"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',

                            },
                        ]}
                    >
                        <RoleSelector
                            value={form.getFieldValue('RoleId')}
                            onChange={(id,value) =>{
                                console.log(id, 'id');
                                console.log(value, 'val');
                                form.setFieldsValue(
                                    {
                                        RoleId: id,
                                    })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{display: 'none'}}
                        label="Platform"
                        name="PlatformId"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',

                            },
                        ]}
                    >
                        <Input type={"hidden"}  disabled />
                    </Form.Item>
                    <Form.Item
                        style={{display: 'none'}}
                        label="Müşteri"
                        name="CustomerId"
                        rules={[
                            {
                                required: true,
                                message: 'Bu alanı doldurunuz',

                            },
                        ]}
                    >
                        <Input type={"hidden"} disabled />
                    </Form.Item>
                    <Form.Item
                        style={{display: 'none'}}
                        label="Yemek"
                        name="ticketCount"
                        rules={[
                            {

                            },
                        ]}
                    >
                        <Input type={"hidden"} disabled />
                    </Form.Item>
                </Form>

            }

        </Modal>

    )
}
